import React from 'react'
import { Cointainer, CustomNavLink, CustomNavLink1 } from '../../style/Sidebar'
import { CustomDiv } from '../../style/shared'
import './sidebar.css';

export const Sidebar = ({ config }) => {
    console.log(config,"config")
    const renderIconWithBadge = (item, isActive) => {
        const showBadge = typeof item.badge === "number" && item.badge > 0;
        return (
            <span className="sidebar-icon-wrap">
                <img
                    src={isActive ? item.activeIcon : item.icon}
                    style={{ width: "21px", margin: '7px 0px 7px 7px' }}
                    alt={item.alt}
                />
                {showBadge && (
                    <span className="sidebar-badge">{item.badge > 9 ? "9+" : item.badge}</span>
                )}
            </span>
        );
    };

    const renderNavLink = (item, isActive) => {
        return (
            <CustomNavLink to={item.path} className={isActive ? 'active' : ''}>
                {renderIconWithBadge(item, isActive)}
            </CustomNavLink>
        );
    };

    return (
        <Cointainer className='noAfter'>
            <CustomDiv marginT="150px">
                {config.map((item, index) => {
                    const isActive = window.location.href.includes(item.path);
                    return item.path ? (
                        renderNavLink(item, isActive)
                    ) : (
                        <CustomNavLink1 key={index} to={item.path}>
                            {renderIconWithBadge(item, false)}
                        </CustomNavLink1>
                    );
                })}
            </CustomDiv>
        </Cointainer>
    );
};



































// import React from 'react'
// import { Cointainer, CustomNavLink, CustomNavLink1, CPersonIcon, CPersonOutlineIcon, CHiOutlineDotsCircleHorizontal, CBiCalendar } from '../../style/Sidebar'
// import { CustomDiv } from '../../style/shared'
// import Cal from "../../assets/sidebar/calendar.svg"
// import User from "../../assets/sidebar/user.svg"
// import Menu from "../../assets/sidebar/menu.svg"
// import Person from "../../assets/sidebar/person.svg"
// import CalA from "../../assets/sidebar/calendarA.svg"
// import UserA from "../../assets/sidebar/userA.svg"
// import MenuA from "../../assets/sidebar/menuA.svg"
// import PersonA from "../../assets/sidebar/personA.svg"

// import './sidebar.css';
// export const Sidebar = () => {
//     return (
//         <Cointainer>
//             <CustomDiv marginT="150px">
//                 <CustomNavLink to="/Calender">
//                     {window.location.href.includes('Calender') && <img src={CalA} style={{ width: "21px", margin: '7px 0px 7px 7px' }} alt="Cal" />}
//                     {!window.location.href.includes('Calender') && <img src={Cal} style={{ width: "21px", margin: '7px 0px 7px 7px' }} alt="Cal" />}
//                 </CustomNavLink>
//                 <CustomNavLink className={window.location.href.includes('People') ? 'active' : window.location.href.includes('Calender') && 'anime'} to="/People/dashboard">
//                     {window.location.href.includes('People') && <img src={UserA} style={{ width: "21px", margin: '7px 0px 7px 7px' }} alt="User" />}
//                     {!window.location.href.includes('People') && <img src={User} style={{ width: "21px", margin: '7px 0px 7px 7px' }} alt="User" />}
//                 </CustomNavLink>
//               <CustomNavLink1  to="" exact>
//                     <img src={Menu} style={{ width: "21px", margin: '7px 0px 7px 7px' }} alt="Menu" />
//                 </CustomNavLink1>
//                 <CustomNavLink1  to="" exact>
//                     <img src={Person} style={{ width: "21px", margin: '7px 0px 7px 7px' }} alt="Person" />
//                 </CustomNavLink1>
//             </CustomDiv>
//         </Cointainer>
//     )
// }

//el idea